import moment from "moment";
import {cloneDeep, isNaN} from "lodash-es";
import {checkNullObj, unitConversion, getDecimalPlacesFast, formatNumberByComma} from "@/pages/datalab/utils/utils";
import {isNumber} from "@/pages/dashboard/utils/utils";
import dataFormat from "@home/utils/dbDataFormat/dataFormat";
import "@/pages/dashboard/components/MetricsTrendCo/index.scss";
import {roundingWithoutZero} from '@home/utils/dbDataFormat/dataFormatUtils';
import {isEmptyValue} from "@home/utils/common";
import { setAloneSymbolOpacity } from '@customComp/Chart/chartConfigs/seriesUtils';

export function checkIsChartDataNull(data: any[]): Boolean {
  if (checkNullObj(data) || data?.length === 0) {
    return true;
  }
  for (const item of data) {
    if (checkNullObj(item)) {
      return true;
    }
  }
  return false;
}

export const handleDate = (pMinDate: any, pMaxDate: any, pDate: any) => {
  const minDate = moment(pMinDate)?.format('YYYY-MM-DD');
  const maxDate = moment(pMaxDate)?.format('YYYY-MM-DD');
  const date = moment(pDate)?.format('YYYY-MM-DD');
  const max = new Date(maxDate);
  const min = new Date(minDate);
  const our = new Date(date);
  if (our > max) return pMaxDate;
  if (our < min) return pMinDate;
  return pDate;
};

// 当事件的开始日期在日期筛选器筛选的开始日期之前时，只展示色块，不展示事件名称
export const isBeforeDate = (date: string, targetDate: string,) => moment(date).isSameOrAfter(targetDate, 'day');

// 数据处理，获取今天开始的事件和非今天开始的事件
const filterEventRecords = (data: { date: any; event_list: any; }) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { date = '', event_list = [] } = data || {};
  const sameDateResult = {
    date,
    events: 0,
    event_list: [] as any[]
  };
  const differentDateResult = {
    date,
    events: 0,
    event_list: [] as any[]
  };

  event_list.forEach((event: { event_type: any; event_record: any; }) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { event_type, event_record } = event;
    const sameDateEvent = {
      event_type,
      event_record: [] as any[],
      events: 0
    };
    const differentDateEvent = {
      event_type,
      event_record: [] as any[],
      events: 0
    };

    event_record.forEach((record: { start_time: any; }) => {
      if (moment(record.start_time)?.format('YYYY-MM-DD') === date) {
        sameDateEvent.event_record.push(record);
        sameDateEvent.events += 1;
      } else {
        differentDateEvent.event_record.push(record);
        differentDateEvent.events += 1;
      }
    });

    if (sameDateEvent.event_record.length > 0) {
      sameDateResult.event_list.push(sameDateEvent);
      sameDateResult.events += sameDateEvent.events;
    }

    if (differentDateEvent.event_record.length > 0) {
      differentDateResult.event_list.push(differentDateEvent);
      differentDateResult.events += differentDateEvent.events;
    }
  });

  return { sameDateResult, differentDateResult };
};

const getEventsContent = (currentEvents: { event_list: any[]; }, eventList: any[], isEN: any) => {
  const data = currentEvents?.event_list || [];
  let str = '';
  // eslint-disable-next-line array-callback-return
  data?.map((eventData: { event_type: any; event_record?: never[] | undefined; events: any; }) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { event_type, event_record = [] } = eventData;
    const eventTypeName = isEN ? (event_type.name_en || event_type.name_cn) : (event_type.name_cn || event_type.name_en);
    let content = '';
    // eslint-disable-next-line array-callback-return
    event_record?.map((record, index) => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const { event_title_en = '', event_title_cn } = record || {};
      const name = isEN ? (event_title_en || event_title_cn ): (event_title_cn || event_title_en);
      const color = eventList?.find((v: any) => v?.name === name)?.color;
      content += `<div class="popover-event-item" key="${index}">
       <div class="popover-event-item-block" style="background-color:${color}"></div>
          ${name}
        </div>`;
    });

    str += `<div class="event-type-details" key="${event_type.id}">
        <div class='popover-event-name'>${eventTypeName}</div>
      <div class='popover-event-desc'>
         ${content}
      </div>
    </div>`;
  });
  return str;
};

export const eventLineFormatterFunc = (params: any, props: any) => {
  const { formatMessage, eventData, eventList, isEn } = props || {};
  const date = params?.[0]?.axisValue || '';

  // hover上去的当日事件
  const currentEvents = eventData?.find((v: any) => moment(v?.date)?.format('YYYY-MM-DD') === moment(date)?.format('YYYY-MM-DD')) || {};
  const { sameDateResult, differentDateResult } = filterEventRecords(currentEvents);
  if (sameDateResult?.events == 0 && differentDateResult?.events == 0) return '';
  return `
    <div class="popover-event events-popover" style="margin-top: ${sameDateResult?.events > 0 ? 12 : 0}px">
    ${sameDateResult?.events > 0 ? `<div>
        <div class="title-flex">
          <div class="title-flex-text">
          <span class="events-text">${formatMessage({ id: "event_info_start_title" })} </span>
          <span class="events-year">(${sameDateResult?.events} ${formatMessage({ id: "event_info_events" })})</span>
          </div>
        </div>
        <div class="popover-event-body">
          ${getEventsContent(sameDateResult, eventList, isEn)}
        </div>
      </div>` : ''}
      ${differentDateResult?.events > 0 ? `<div class='events-popover-deferent'>
        <div class="title-flex">
        <div class="title-flex-text">
        <span class="events-text">${formatMessage({ id: "event_info_today_title" })} </span>
          <span class="events-year">(${differentDateResult?.events} ${formatMessage({ id: "event_info_events" })})</span>
        </div>
      </div>
      <div class="popover-event-body">
        ${getEventsContent(differentDateResult, eventList, isEn)}
      </div>
      </div>` : ''}
    </div>
    `;
};

export const eventXAxisHighLight = (opt: any, config: any = { isRealtime: false, isDateComparison: false, symbolSize: 10, fontSize: 10 }) => {
  // eslint-disable-next-line no-param-reassign
  opt.series = opt.series?.map((seriesItem: any) => {
    const nextSeries = {
      ...seriesItem,
      data: seriesItem?.data?.map((item: any) => ({
        ...item,
        value: item?.value,
        itemStyle: {
          ...(item?.itemStyle ?? {}),
          opacity: 0,
        },
        symbol: 'circle',
      })),
      symbolSize: config?.symbolSize || 10,
      emphasis: {
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1,
          borderType: 'solid',
          opacity: 1,
        },
      },
    };
    setAloneSymbolOpacity([nextSeries]);
    return nextSeries;
  });
  
  // eslint-disable-next-line no-param-reassign
  opt.tooltip.axisPointer = {
    ...opt.tooltip.axisPointer,
    z: 10,
    label: {
      show: true,
      // backgroundColor: 'transparent',
      backgroundColor: '#ffffff',
      fontSize: config?.fontSize || 10,
      color: '#262832',
      fontWeight: 700,
      formatter: (params: { axisIndex: number; value: any; }) => {
        // 上下排列的图表（下方图表不需要展示x轴浮窗）对比分析需要展示
        if (params?.axisIndex > 0 && !config?.isDateComparison) return null;
        return config.formatter ? config.formatter(params) : params.value;
      }
    },
    lineStyle: config?.lineStyle || {
      color: '#cccccc',
      width: 1,
      type: 'solid'
    },
  };
  return opt;
};

export const tooltipSort = (a: string, b: string): number => {
  
  // 将字符串转换为数字进行比较
  const numA = Number(a);
  const numB = Number(b);
  
  // 处理 '-' 和 undefined 的情况
  const aIsNull = !a || isNaN(numA);
  const bIsNull = !b || isNaN(numB);
  if (aIsNull && bIsNull) return 0;
  if(aIsNull) return 1;
  if(bIsNull) return -1;
  
  // 从大到小排序
  return numB - numA;
};


// 定义一个辅助函数来移除毫秒
// 使用正则表达式查找并移除毫秒部分
export const removeMilliseconds=(dateStr: string)=> dateStr?.replace(/\.\d{3,6}$/, '');

export const isValidDate = (str: string) => {
  const dateStrWithoutMills = removeMilliseconds(str);
  // 预处理日期字符串，将日转换为01-31的格式,DD格式只处理1-30这种情况
  const processedDateStr = dateStrWithoutMills==='31' ? 30 : dateStrWithoutMills;
  const momentObj = moment(processedDateStr, [
    "YYYY-MM-DD",
    "MM-DD-YYYY",
    "YYYY-MM",
    "MM-DD",
    "YYYY",
    "MM",
    "DD",
    "YYYY-MM-DD HH:mm:ss",
    "HH:mm:ss",
    "HH:mm"
  ], true);
  return momentObj.isValid();
};

// 定义checkAllDatesValid函数，它接受一个日期数组并检查所有日期是否有效
export const checkAllDatesValid = (dateArray: any[]) => dateArray.every((date) => isValidDate(date));

// 判断传入的元素是否全为空值
const isAllValuesUndefined = (arr: any[]) => arr.every((item) => !item.value);

// 是否是百分比字符串
const isPercentString = (value: string) => {
  if (typeof value === "string" && value.endsWith("%")) {
    return !isNaN(parseFloat(value));
  }
  return false;
};
// 针对原数据，往头部增加一列汇总
export const getIncrementSum = (paramColumns: any[], incrementSum: boolean, isEn?: boolean)=>{
  // 克隆外部数据源，只增加新数据，不修改原始数据
  const dataSource = cloneDeep(paramColumns);
  // 在头部增加汇总值
  dataSource?.forEach((column) => {
    if (Array.isArray(column)) {
      // 使用 reduce 方法计算总数，并判断是否全为空
      const { total, isNull, decimal } = column.reduce(
        (sum, item) => {
          if (isNumber(item.value)) {
            // 如果 item.value 是数字，则将其加到总和中
            const decimal = getDecimalPlacesFast(item.value);
            return {
              total: sum.total + Number(item.value),
              isNull: sum.isNull,
              decimal: Math.max(decimal, sum.decimal),
            };
          }
          // 其他情况保持原样
          return sum;
        },
        {
          // 初始总和为 0
          total: 0, 
          // 是否存在空值的标志，初始为判断整个数组的结果，考虑0和空的情况
          isNull: isAllValuesUndefined(column),
          decimal: 0, // 小数位数
        },
      );
      // 重新计算并赋值 percent
      column.forEach((item) => {
        if (
          item?.data?.percent &&
          isPercentString(item?.data?.percent)
        ) {
          // 如果 total 为 0，返回 0,避免NAN的情况
          // 保证除数以及被除数不等于0，
          const value =
            // eslint-disable-next-line no-nested-ternary
            total !== 0 && item?.value
              ? parseFloat(item?.value) / total
              : parseFloat(item?.value) === 0
                ? 0
                : '';
          item.data.percent = numericalConversionFormat(value);
        } else {
          item.data.percent = undefined;
        }
      });
      // 获取这条柱子是否存在valueIsPercent
      const valueIsPercent = column.some(task=>task.data?.valueIsPercent);
      // // 查找第一条数据，针对小数位进行切割
      // const digit = valueIsPercent && column.find(task=>task.data.value)?.data.value?.split('.')?.[1];
      // let resTotal = total;
      // if (valueIsPercent && digit) {
      //   // 直接使用模板字符串拼接，避免多余的空格以及复杂的条件判断
      //   resTotal = `${resTotal}.${digit}`;
      // }
      
      // 根据小数位数, 截取Total值
      const result = dataFormat({
        value: total,
        formatRule: {
          type: 'decimals',
          decimal,
        },
        fillZero: true,
      });
  
      incrementSum && column.unshift({
        marker: '',
        seriesName: isEn ? 'Total' : '总计',
        // 如果当前浮窗下全是空值，展示'-',反之亦然
        value: !isNull ? result : '-' ,
        data: {
          // 如果当前浮窗下全是空值，展示'-',反之亦然
          percent: !isNull ? '100%' : '-',
          axisPoint: column?.[column?.length-1]?.data?.axisPoint,
          valueIsPercent ,
          isTotal: true,
        },
      });
    }
  });
  return dataSource;
};

export function formatPercent(value: string, avg?: boolean) {
  // 将传入的值转换为浮点数
  const numValue = parseFloat(value);
  if (!numValue && numValue !== 0) {
    return '';
  }
  // 判断正数和负数的情况
  if (numValue > 999.9) {
    // 正数大于999，返回'999.9%'
    return '999.9%+';
  }
  if (numValue < -999.9) {
    // 负数小于-999，返回'-999.9%'
    return '-999.9%+';
  }
  // 否则返回原始值
  return avg ? `${value}%` : value;
};
// 是否是科学计数法
const isScientificNotation = (num) =>
  /\d+\.?\d*e[+-]?\d+/i.test(num.toString());

// 简单处理一下极限数值情况
const numericalConversionFormat = (value) => {
  let number;
  // 如果是极限值，统一保留2位
  if (isScientificNotation(value)) {
    number = dataFormat({
      value: value?.toFixed(2),
      formatRule: 'percent2Decimal',
    });
  // 反之，不做四舍五入
  } else {
    number = dataFormat({ value, formatRule: 'percent2Decimal' });
  }
  return number;
};


// TODO 如果没有改动 等home仓库更新release 可以直接引用home仓

/**
 * @description: 格式化数据
 * @param {string} value 传入的需要格式化的值
 * @param {string | Function | undefined} formatter  格式化规则，可以传入字符串或者函数
 * @return {string}
 */
export const formatVal = (value: string | number, formatter: string | Function | undefined) => {
  // 不存在格式化信息则直接返回原值
  if (!formatter) {
    return value;
  }
  // 如果是方法，则直接用自定义的方法
  if (typeof formatter === 'function') {
    return formatter?.(value);
  }
  return dataFormat({ value, formatRule: formatter });
};


/**
 * 获取显示label的下标, 第一个点和最后一个点必须展示label
 * @param total 总共有多少个点
 * @param count 显示几个label
 * @returns number[] 显示label的 下标数组
 */

export const getIntervalIndex: (total: number, count: number) => number[] = (total, count = 7) => {

  if (total <= count) return Array.from({ length: total ?? 0 }, (_, i) => i);
  
  // 初始化结果数组
  const indices = [total - 1];
  
  // 计算中间元素的个数
  const middleCount = count - 2;
  
  // 计算间隔
  const interval = Math.round((total - 2) / (middleCount + 1));
  
  /**
   * indices[0] 是 total-1, 最大的下标
   * 从最大的下标 向前计算 需要显示label的 下标
   * 当间隔无法均分时, 尽量显示 大的下标的 label
   */
  for (let i = 1;i < middleCount;i++) {
    indices.push(indices[0] - (i * interval));
  }
  
  /**
   * 某些情况下 计算出来的倒数第二个下标元素 会和 最后一个元素0相同, 导致无法得到 7个不同下标
   * 比如 传入 total=11 count=7
   * 所以这里对 倒数第二个下标 进行判断
   */
  // 倒数第二个下标元素
  const lastSecond = indices[0] - (middleCount * interval);
  
  if (lastSecond === 0) {
    indices.push(1, 0); // 最后一个元素是 0
  } else {
    indices.push(lastSecond, 0); // 最后一个元素是 0
  }
  
  // 返回生成的数组
  return indices;
};


/**
 * 获取数值标签的偏移量
 * @param {string | any[]} data 传入的数据，series对应的data
 * @param {value} string 传入的对比值
 * @param {number} index 第几个点
 * @param {string} type 图表的类型
 * @return {string []}
 */
export const getOffset = (data: string | any[], value: string, index: number, type: string) => {
  const length = value?.length;
  const getXOffset = (length: number) => {
    switch (true) {
      case length <= 3: return 8;
      case length <= 4: return 12;
      case length > 4 && length <= 6: return 14;
      case length > 6 && length <= 8: return 16;
      case length > 8 && length <= 10: return 18;
      case length > 10 && length <= 12: return 20;
      default: return 22;
    }
  };
  const offsetTop = 4;
  // (柱状图少量数据 数据标签不需要偏移)
  // 第一个点向右偏移避免画布小的时候被裁减
  // 14个以下，柱状图是能正常展示，不用偏移
  if (index === 0) {
    if (type === 'bar' && data?.length <= 14) return [0, offsetTop];
    return [getXOffset(length), offsetTop];
  }
  // 最后一个点向左偏移避免画布小的时候被裁减
  if (index === data?.length - 1) {
    if (type === 'bar' && data?.length <= 14) return [0, offsetTop];
    return [-getXOffset(length), offsetTop];
  }
  return [0, offsetTop];
};

/**
 * 计算 x 轴 最后一个点的 label 偏移量, 尽量不被遮盖
 * @param label 显示的label文本
 * @param singleWidth 单个字符宽度
 * @param offsetWidth
 */
export const getLabelXOffset: (label: any, singleWidth?: number, offsetWidth?: number) => number = (label, singleWidth = 6, offsetWidth = 0) => 
  // 暂定一个字符默认占位6px
  String(label).length / 2 * singleWidth - offsetWidth || 0
;

/**
 * Y轴展示
 * *整数展示为BMK
 * *百分比类型 和 没有bmk单位的整数按照下列逻辑处理
 *    * 整数可以为整数
 *    * 小数 四舍五入, 最多展示两位小数
 *        * 1.2 展示为 1.2;  不展示为 1.20
 *        * 2.8234 展示为 2.82
 * @param value
 * @param isPercent
 */
export const formatY = (value: number, isPercent: boolean): string => {
  if (isPercent) { // 百分比类型
    return `${roundingWithoutZero(value, 2)}%`;
  }
  // bmk 单位
  const bmk = unitConversion(value, true);
  // 有bmk单位的直接返回
  // 没有bmk单位的，返回最多保留两位小数的数值
  return Number(bmk) ? roundingWithoutZero(bmk, 2) : bmk;
};

/**
 * 格式化汇总数据
 * @param value 汇总数据
 * @param metricInfo 指标信息
 * @returns 格式化后的汇总数据
 */
export const formatTotalNum = (value: string | number, metricInfo?: { accuracy: any; column_date_type: string; unit?: string; }) => {
  const decimal = metricInfo?.accuracy ?? 0;
  const isPercent = metricInfo?.column_date_type === 'percent' || false;
  if (isPercent) {
    const fixedValue = Number(value)?.toFixed(decimal);
    // 0值需要展示
    const metricValue = value || Number(value) === 0 ? formatNumberByComma(fixedValue) : '-';
    return `${metricValue}%`;
  }
  return dataFormat({
    value,
    emptyValue: '-',
    fillZero: true,
    formatRule: {
      type: metricInfo?.unit || 'bmk',
      decimal,
    },
  }) as string;
};

export interface IFormatDisplayValueParams {
  value: string | number;
  isPercent?: boolean;
  accuracy?: number;
  unit: string;
  emptyValue?: string;
  fillZero?: boolean;
}

/**
 * 格式化显示值
 * @param params - 格式化参数
 * @param params.value - 值
 * @param params.isPercent - 是否为百分比
 * @param params.accuracy - 精确度（小数位数）
 * @param params.unit - 单位类型
 * @returns 格式化后的字符串
 */
export const formatDisplayValue = ({ value, isPercent = false, accuracy = 0, unit, emptyValue = '-', fillZero = true }: IFormatDisplayValueParams): string => {
  if (isEmptyValue(value)) {
    return emptyValue;
  }
  // 百分比类型的小数位数后端会计算好返回, 这里不需要前端处理
  if (isPercent) {
    return (String(value).endsWith("%") ? value : `${value}%`) as string;
  }
  return dataFormat({
    value: value === 'null' ? '-' : value,
    emptyValue,
    fillZero,
    formatRule: {
      type: unit,
      decimal: accuracy,
    },
  }) as string;
};